module.exports = __webpack_public_path__ + "Deploy.54239cc35533a87d2e111c735e420514.hashedasset.svg";